import { createStore } from 'zustand/vanilla';
import { parseFrameworkPart } from './parts';
import { EMPTY_RUN_STATE, reduceFrameworkPart } from './run-state';
export function createRunStore(initial = {}) {
    return createStore()((set) => ({
        ...EMPTY_RUN_STATE,
        ...initial,
        applyPart: (part) => {
            const parsed = parseFrameworkPart(part);
            if (!parsed)
                return false;
            set((state) => reduceFrameworkPart(state, parsed));
            return true;
        },
        addTraceEvent: (event) => {
            set((state) => ({ trace: [...state.trace, event] }));
        },
        updateExtension: (key, update) => {
            set((state) => ({
                extensions: {
                    ...state.extensions,
                    [key]: update(state.extensions[key]),
                },
            }));
        },
        reset: () => {
            set({ ...EMPTY_RUN_STATE });
        },
    }));
}
/**
 * Rebuilds run state from messages that already hold the persistent parts, so a reloaded
 * conversation shows the runs it had without replaying the stream.
 */
export function runStateFromMessages(messages) {
    const store = createRunStore();
    for (const message of messages) {
        for (const part of message.parts) {
            if (part.type.startsWith('data-'))
                store.getState().applyPart(part);
        }
    }
    const { runs, runOrder, nodes, guardrails, suspensionTokens } = store.getState();
    return { runs, runOrder, nodes, guardrails, suspensionTokens };
}
